import React, { PureComponent } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

import styles from './index.css';

import { classNames } from '@ifeng-fe/container_channel/common/client/utils/classnames';

class TabsPane extends PureComponent {
    static propTypes = {
        children: PropTypes.element,
    };

    render() {
        const { children } = this.props;

        return <div>{children}</div>;
    }
}

class Tabs extends PureComponent {
    static propTypes = {
        // onChange: PropTypes.func,
        children: PropTypes.node,
        content: PropTypes.array,
        current: PropTypes.string,
        handleChange: PropTypes.func,
    };

    state = {
        current: this.props.content[0].title,
    };

    handleClick = current => {
        // this.setState({
        //     current,
        // });
        this.props.handleChange(current);
    };

    render() {
        // const { current } = this.state;
        const { children, content, current } = this.props;

        return (
            <div className={styles.tabs}>
                <div className={styles.tabs_list}>
                    {content.map(item => (
                        <div
                            key={item.title}
                            className={classNames(styles.tabsItem)}
                            onClick={() => this.handleClick(item.title)}
                            style={{
                                backgroundImage:
                                    current === item.title ? `url(${item.icon})` : `url(${item.icon_active})`,
                            }}
                        />
                    ))}
                </div>
                {children.map(item => current === item.key && <div key={item.key}>{item}</div>)}
            </div>
        );
    }
}

export { TabsPane };
export default errorBoundary(Tabs);
